import Vue from "vue";
import App from "./App.vue"; //引入跟组件
import router from "./router";
import "./plugins/element.js";
// import VueResource from 'vue-resource'
// Vue.use(VueResource)
// 导入全局样式
import "./assets/css/common.css";
import "./assets/css/style.min.css";
//导入字体图标
import "./assets/fonts/iconfont.css";
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

// 轮播图

// 导入后台富文本样式
// import "./assets/css/chunk-vendors.2c81742b.css"
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n=new VueI18n({
    locale:window.sessionStorage.getItem("language")||'cn',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
        'cn':require('./components/language/cn'),
        'en':require('./components/language/en')
    }
})

Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})
    
Vue.use(vueSwiper)
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
import axios from "axios";
//配置请求根路径
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://47.116.134.87:18901';
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://www.jqinvestments.com/interface' : 'https://www.jqinvestments.com/interface';
//在挂载到原型对象前先设置一个request请求拦截器，使用use挂载一个回调函数
//config就是请求对象
//请求到达服务器之前先调用这个回调函数，对headers做预处理
axios.interceptors.request.use(config => {
  config.headers['content-type'] = 'application/json';
  // config.headers.Authorization = window.sessionStorage.getItem("token");
  config.headers.token = window.sessionStorage.getItem("token")?window.sessionStorage.getItem("token"):'';
  config.headers.language = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'';
  return config;
});
axios.interceptors.response.use(result => {
  if(result.data && result.data.code == 501) {
    return router.replace('/login')
  }
  return result;
});

//将引入的axios挂载到vue的原型对象上，全局配置axios，
Vue.prototype.$http = axios;

Vue.config.productionTip = false;

new Vue({
  router,
   i18n,   //把 i18n 挂载到 vue 根实例上
  render: h => h(App)
}).$mount("#app");
